<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">{{ new Date().getFullYear() }} © {{ entidade.ent_nome }}</div>
        <div class="col-sm-6">
          <div class="text-sm-right d-none d-sm-block">{{ develop }}</div>
        </div>
      </div>
    </div>
  </footer>
</template>


<script>
import appConfig from "@/dados/app.config.json";

export default {
  data() {
    return {};
  },
  computed: {
    entidade() {
      return this.$store ? this.$store.state.auth.currentEntidade : null;
    },
    develop() {
      if (process.env.NODE_ENV === 'development') {
        return 'Versão: ' + appConfig.versao + ' - Desenvolvimento';
      } else {
        return appConfig.develop + ' - Versão: ' + appConfig.versao
      }
    },
  },
};
</script>
